import hero from "../../../../image/hero.png";
import ElementContext from "../ElementModal";
import {
  Input,
  Button,
  Checkbox,
  RadioButton,
  Rating,
  Select,
  Slider,
  Switch,
  DropDown,
  ToggleButton,
} from "../../../../../../../../constants/db";

interface ImageTextObject {
  image: string;
  text: string;
  sourceCode: string;
  description: string;
}

const textLists: ImageTextObject[] = [
  {
    image: hero,
    text: "Input",
    sourceCode: Input.code,
    description: Input.description,
  },
  {
    image: hero,
    text: "Button",
    sourceCode: Button.code,
    description: Button.description,
  },
  {
    image: hero,
    text: "Checkbox",
    sourceCode: Checkbox.code,
    description: Checkbox.description,
  },
  {
    image: hero,
    text: "Radio button",
    sourceCode: RadioButton.code,
    description: RadioButton.description,
  },
  {
    image: hero,
    text: "Rating",
    sourceCode: Rating.code,
    description: Rating.description,
  },
  {
    image: hero,
    text: "Select",
    sourceCode: Select.code,
    description: Select.description,
  },
  {
    image: hero,
    text: "Slider",
    sourceCode: Slider.code,
    description: Slider.description,
  },
  {
    image: hero,
    text: "Switch",
    sourceCode: Switch.code,
    description: Switch.description,
  },
  {
    image: hero,
    text: "Drop down",
    sourceCode: DropDown.code,
    description: DropDown.description,
  },
  {
    image: hero,
    text: "Toogle button",
    sourceCode: ToggleButton.code,
    description: ToggleButton.description,
  },
];

export default function FormsPage() {
  return (
    <section className="layoutPages">
      {" "}
      <h2 className="layoutPages_heading">Form components</h2>
      <p className="layoutPages_info">
        Here is a list of all the prebuilt form components that PlayBox makes
        available for use.
      </p>
      {/* compoonets */}
      <div>
        <ElementContext imageTextArray={textLists} />
      </div>
      <p className="coming-soon"> More coming soon ✌️ </p>
    </section>
  );
}
